/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Danish (Denmark)
export default {
  'ai-mate.chat-error-banner.description': 'Din chathistorik gemmes i op til 30 dage.',
  'ai-mate.chat-error-banner.title': 'Start ny chat',
  'ai-mate.chat-error.description': 'Prøv at <btn>genindlæse chat</btn>.',
  'ai-mate.chat-error.rate-limited-description': 'Du har nået det maksimale antal anmodninger. Prøv igen senere.',
  'ai-mate.chat-error.rate-limited-title': 'For mange anmodninger',
  'ai-mate.chat-error.rovo-inactive-description':
    'Det ser ud til, at Rovo ikke er aktiveret på dit website. <link>Opsætning af Rovo</link>',
  'ai-mate.chat-error.rovo-inactive-title': 'Rovo er inaktiv',
  'ai-mate.chat-error.title': 'Vi er ikke sikre på, hvad der gik galt',
  'ai-mate.chat-input.file-close-icon-label': 'Fjern fil',
  'ai-mate.chat-input.file-error-icon-label': 'Fejl ved indlæsning af fil',
  'ai-mate.chat-view.chat-item.chat-delete-label': 'Slet',
  'ai-mate.chat-view.chat-item.chat-options-for-conversation-button-label': 'Chatindstillinger for {conversationName}',
  'ai-mate.chat-view.chat-item.chat-rename-label': 'Omdøb',
  'ai-mate.common.ui.expandable-section.collapse': 'Skjul',
  'ai-mate.common.ui.expandable-section.expand': 'Udvid',
  'ai-mate.conversation-assistant.conversation-picker.delete-confirm-modal.cancel-button-label.non-final': 'Annuller',
  'ai-mate.conversation-assistant.conversation-picker.delete-confirm-modal.conversation-not-found-failure-message.non-final':
    'Den samtale, du forsøger at slette, findes ikke.',
  'ai-mate.conversation-assistant.conversation-picker.delete-confirm-modal.delete-button-label.non-final': 'Slet',
  'ai-mate.conversation-assistant.conversation-picker.delete-confirm-modal.delete-conversation-title.non-final':
    'Slet samtalen "{name}"?',
  'ai-mate.conversation-assistant.conversation-picker.delete-confirm-modal.generic-failure-message.non-final':
    'Der opstod en fejl under sletning af samtalen. Prøv igen.',
  'ai-mate.conversation-assistant.conversation-picker.delete-confirm-modal.modal-body.non-final':
    'Er du sikker på, at du vil slette denne samtale? Handlingen kan ikke fortrydes.',
  'ai-mate.conversation-assistant.conversation-picker.edit-modal.cancel-button-label.non-final': 'Annuller',
  'ai-mate.conversation-assistant.conversation-picker.edit-modal.channel-not-found-error-message.non-final':
    'Den kanal, du forsøger at redigere, findes ikke.',
  'ai-mate.conversation-assistant.conversation-picker.edit-modal.edit-name-label.non-final': 'Navn',
  'ai-mate.conversation-assistant.conversation-picker.edit-modal.generic-error-message.non-final':
    'Der opstod en fejl under redigering af samtalen. Prøv igen.',
  'ai-mate.conversation-assistant.conversation-picker.edit-modal.modal-title.non-final': 'Rediger samtale',
  'ai-mate.conversation-assistant.conversation-picker.edit-modal.name-is-same-error-message.non-final':
    'Navnet er det samme som det nuværende navn.',
  'ai-mate.conversation-assistant.conversation-picker.edit-modal.save-button-label.non-final': 'Gem',
  'ai-mate.conversation-list-view.accessible-search-results':
    '{results, plural, one {Der blev fundet {results,number} resultat} other {Der blev fundet {results,number} resultater}}',
  'ai-mate.conversation-list-view.back-button.label': 'Tilbage',
  'ai-mate.conversation-list-view.close-chat-button.label': 'Luk chat',
  'ai-mate.conversation-list-view.header-title': 'Chathistorik',
  'ai-mate.conversation-list-view.new-chat-button.label': 'Ny chat',
  'ai-mate.conversation-list-view.no-chat': 'Ingen resultater',
  'ai-mate.conversation-list-view.search-input.placeholder': 'Søg i chats',
  'ai-mate.expander.hide-details': 'Skjul detaljer',
  'ai-mate.expander.show-details': 'Vis flere oplysninger',
  'ai-mate.main-chat.close-chat-panel-button-label': 'Luk chat',
  'ai-mate.main-chat.maximize-chat-button-label': 'Fuld skærm',
  'ai-mate.main-chat.minimize-chat-button-label': 'Gendan visning',
  'ai-mate.main-chat.new-chat-button-label': 'Ny',
  'ai-mate.main-chat.new-chat-button-label-full-screen': 'Ny chat',
  'conversation-assistant-button.rovo-chat-label': 'Rovo Chat',
  'highlight-actions.rovo-chat-custom-prompt-submit-button.text': 'Send',
  'highlight-actions.rovo-chat-custom-prompt.placeholder': 'Spørg AI om dette',
  'highlight-actions.rovo-chat-explain-option.text': 'Forklar',
  'highlight-actions.rovo-chat-explain-prompt':
    'Forklar dette ved at omformulere det og tilføje yderligere oplysninger, men brug meget simpelt sprog og korte sætninger, og giv eksempler eller definitioner på eventuel teknisk terminologi, der er brugt i den oprindelige formulering.',
  'highlight-actions.rovo-chat-find-resources-option.text': 'Find ressourcer',
  'highlight-actions.rovo-chat-find-resources-prompt':
    'Find ressourcer udelukkende inden for organisatorisk viden, der støtter de foretagne erklæringer.',
  'highlight-actions.rovo-chat-give-examples-option.text': 'Giv eksempler',
  'highlight-actions.rovo-chat-give-examples-prompt':
    'Giv eksempler på dette fra organisationsressourcer eller offentlig viden. Hvis der ikke kan ydes nogen ressourcer, kan du forsøge at give et metaforisk eksempel, der muligvis kan hjælpe nogen med at forstå dette bedre.',
  'highlight-actions.rovo-chat-give-feedback-option.text': 'Giv feedback',
  'highlight-actions.rovo-chat-give-feedback-prompt':
    'Giv feedback ved at gennemgå formuleringen af dette. Kommentér på ordvalg, grammatik og tegnsætning. Vær positiv og entusiastisk, men angiv altid mindst én ting, der kan forbedres eller ændres.',
  'highlight-actions.rovo-chat-more-options.tooltip': 'Chatanbefalinger',
  'highlight-actions.rovo-chat-open-chat.tooltip': 'Åbn Chat',
  'highlight-actions.rovo-chat-summarize-option.text': 'Opsummer',
  'highlight-actions.rovo-chat-summarize-prompt':
    'Fremhæv de vigtigste punkter fra dette. Fokusér på essentielle oplysninger, og udeluk unødvendige detaljer. Giv et kortfattet overblik i et enkelt afsnit.',
  'highlight-actions.rovo-chat.ask-in-chat-button-text': 'Spørg i Chat',
  'highlight-actions.rovo-chat.placeholder-prompt': 'Stil et spørgsmål om dette.',
  'horizontal-scroll-container.scroll-left': 'Rul til venstre',
  'horizontal-scroll-container.scroll-right': 'Rul til højre',
  'rovo-chat.deep-research-spotlight.description':
    'Slå Dyb forskning til, og indtast en prompt. Rovo opretter en plan, gennemfører undersøgelserne og genererer en komplet rapport.',
  'rovo-chat.deep-research-spotlight.dismiss': 'Luk',
  'rovo-chat.deep-research-spotlight.heading': 'Introduktion til Dyb forskning i Rovo',
  'rovo-chat.file-upload-dropzone.drag-drop-message': 'Træk og slip for at tilføje kontekst',
  'rovo-chat.message-file.icon-label': 'Fil',
  'rovo-chat.search-input.screen-reader-prompt':
    'Hvis du indtaster et tegn i dette felt, opdateres søgeresultaterne nedenfor',
};
